import { Warning } from '@phosphor-icons/react/dist/icons/Warning';

export function Kpi({ label, value, sub, alert }: { label: string; value: string; sub: string; alert?: boolean }) {
  return (
    <div
      className={[
        'flex flex-col gap-1 rounded-2xl p-4',
        alert ? 'bg-bg-red-light' : 'border border-border-primary bg-bg-primary',
      ].join(' ')}
    >
      <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-content-tertiary">{label}</span>
      <span className="text-2xl font-semibold tracking-tight">{value}</span>
      <span className={`flex items-center gap-1 text-xs ${alert ? 'text-text-red' : 'text-content-tertiary'}`}>
        {alert && <Warning size={12} weight="bold" />}
        {sub}
      </span>
    </div>
  );
}

export function Panel({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <div className={`rounded-2xl border border-border-primary bg-bg-primary p-5 ${className}`}>{children}</div>;
}
